import { render, staticRenderFns } from "./Lista.vue?vue&type=template&id=7883ffc0&scoped=true&"
import script from "./Lista.vue?vue&type=script&lang=ts&"
export * from "./Lista.vue?vue&type=script&lang=ts&"
import style0 from "./Lista.vue?vue&type=style&index=0&id=7883ffc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7883ffc0",
  null
  
)

export default component.exports